import utils from '../../../utils';
import React, { useState, useEffect } from 'react';
import YouTube from 'react-youtube';
import axios from 'axios';
import cmsUtils from "../../utils/cmsUtils";
import './style.scss';

export function YouTubeWithPlaylist(props) {
    const item = props.item;
    const cmsOption = props.cmsOption || {};
    const videoCode = cmsUtils.payload(item, "YoutubeCode");

    const videosPerPage = 4;
    const [videoList, setVideoList] = useState([]);
    const [currentVideoId, setCurrentVideoId] = useState('');
    const [startIndex, setStartIndex] = useState(0);

    const playlistId = `${videoCode}`;
    const API_KEY = 'AIzaSyAtuNCYY5OdcjDEVWuQZFkqdEiwUecEuGM';
    const API_URL = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=500&playlistId=${playlistId}&key=${API_KEY}`;

    const cssClass = utils.classNames(
        "cms_item",
        "youtubePanel",
        "youtube-with-playlist",
        "youtube-container",
        item.cssClass || item.anchorName || ""
    );

    useEffect(() => {
        const fetchAllVideos = async () => {
            let allVideos = [];
            let nextPageToken = '';

            do {
                const response = await axios.get(API_URL + (nextPageToken ? `&pageToken=${nextPageToken}` : ''));
                const videos = response.data.items.map(item => ({
                    id: item.snippet.resourceId.videoId,
                    title: item.snippet.title,
                    thumbnail: item.snippet.thumbnails.medium.url,
                }));

                allVideos = [...allVideos, ...videos];
                nextPageToken = response.data.nextPageToken || '';

            } while (nextPageToken);

            setVideoList(allVideos);
            setCurrentVideoId(allVideos[0]?.id || '');
        };

        fetchAllVideos().catch(error => console.error('Error fetching playlist:', error));
    }, []);

    const opts = {
        height: '100%',
        width: '100%',
        playerVars: {
            autoplay: 1,
            mute: 1,
        },
    };

    const handlePrev = () => {
        setStartIndex(prev => Math.max(prev - videosPerPage, 0));
    };

    const handleNext = () => {
        setStartIndex(prev => Math.min(prev + videosPerPage, videoList.length - videosPerPage));
    };

    const offset = `-${(startIndex / videosPerPage) * 100}%`;

    return (
        <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
            {/* main play window */}
            <YouTube videoId={currentVideoId} opts={opts} className='main-video-container' />
            <div className="playlist-container">
                {/* thumbnails list */}
                <div className="video-thumbnails" style={{ transform: `translateX(${offset}%)` }}>
                    {videoList.slice(startIndex, startIndex + videosPerPage).map(video => (
                        <div key={video.id} className="thumbnail" onClick={() => setCurrentVideoId(video.id)}>
                            <img src={video.thumbnail} alt={video.title} />
                        </div>
                    ))}
                </div>
            </div>
            <div className='arrow-container'>
                <button className="arrow left" onClick={handlePrev} disabled={startIndex === 0}>← Prev</button>
                <button className="arrow right" onClick={handleNext} disabled={startIndex + videosPerPage >= videoList.length}>Next →</button>
            </div>
        </div>
    )

}